/**
 * numberCoerce.js
 *
 * Tiny numeric-coercion helpers shared by the dashboard coloring-schema editors. Kept out of the
 * pure coloring vocabulary module (coloringSchemas.js) because these are generic value coercions,
 * not coloring concepts.
 */

/**
 * Coerce a form value to a finite Number, or null when it is blank / absent / non-numeric.
 * Used by the band editors so an empty or half-typed boundary reads as "unbounded" (null) rather
 * than NaN.
 * @param {*} v raw input (string from a text field, number, null, or undefined)
 * @returns {number|null}
 */
export function numOrNull(v) {
  if (v === null || v === undefined || v === '' || Number.isNaN(Number(v))) return null;
  return Number(v);
}
